import React from 'react'
import { Link, useLocation, useHistory } from "react-router-dom";

const Navbar = () => {
    let location = useLocation();
    let history = useHistory();

    const handleLogout = () => {
        localStorage.removeItem('token');
        history.push('/login');
    }
    return (
        <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-warning">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">eNotes</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    {localStorage.getItem('token') ? 
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                         <li className="nav-item">
                             <Link className={`nav-link ${location.pathname === "/" ? "active" : ""}`} aria-current="page" to="/">Home</Link>
                         </li>
                         <li className="nav-item">
                             <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about">About</Link>
                         </li>
                      </ul> :
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                          <li className="nav-item">
                              <Link className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} to="/about">About</Link>
                          </li>
                       </ul>
                    }
                    {!localStorage.getItem('token') ? <form className="d-flex">
                        <Link className="btn btn-secondary mx-1" to="/login" role="button">LogIn</Link>
                        <Link className="btn btn-secondary mx-1" to="/signup" role="button">SignUp</Link>
                    </form> :
                        <button className="btn btn-secondary" onClick={handleLogout}>LogOut</button>}
                </div>
            </div>
        </nav>
    )
}

export default Navbar
